module.exports = __webpack_public_path__ + "img/Shayofae google analytics 2.f20ffc98.png";